<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12
        ><v-subheader>{{ bank_name }} {{ rate_name }}</v-subheader></v-flex
      >
      <v-flex xs12 sm12 md12>
        <v-textarea
          type="text"
          append-icon="save"
          @click:append="updateComment"
          v-model="geo_note"
          label="Регионы (примечание)"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md6>
        <h2>Территория работы банка (Принципал):</h2>
        <v-btn @click="getGeoForVid(1)">Считать принципалов</v-btn>
        <v-btn @click="updateGeo(1)">Записать принципалов</v-btn>
        <v-treeview
          :items="items"
          v-model="principals"
          activatable
          active-class="grey lighten-4 indigo--text"
          selected-color="indigo"
          open-on-click
          selectable
          expand-icon="mdi-chevron-down"
          on-icon="mdi-bookmark"
          off-icon="mdi-bookmark-outline"
          indeterminate-icon="mdi-bookmark-minus"
        ></v-treeview>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <h2>Территория работы банка (Бенефициар):</h2>
        <v-btn @click="getGeoForVid(2)">Считать бенефициаров</v-btn>
        <v-btn @click="updateGeo(2)">Записать бенефициаров</v-btn>
        <v-treeview
          :items="items"
          v-model="beneficiars"
          activatable
          active-class="grey lighten-4 indigo--text"
          selected-color="indigo"
          open-on-click
          selectable
          expand-icon="mdi-chevron-down"
          on-icon="mdi-bookmark"
          off-icon="mdi-bookmark-outline"
          indeterminate-icon="mdi-bookmark-minus"
        ></v-treeview>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";

export default {
  props: {
    GeoID: Number
  },
  watch: {
    // эта функция запускается при любом изменении вопроса
    GeoID: function(NewVal, OldVal) {
      this.rate_id = NewVal;
      this.getGeo(NewVal);
    }
  },
  data: () => ({
    rate_id: null,
    tree: [],
    items: [],
    principals: [],
    beneficiars: [],
    dataToUpdate: [],
    geo_note: "",
    rate_name: "",
    bank_name: ""
  }),
  created() {},
  mounted() {
    this.rate_id = this.GeoID;
    this.getGeo();
  },
  methods: {
    getGeo() {
      this.$store.dispatch('getGeo',this.rate_id )
        .then(response => {
          let makeTree = array =>
            array.filter(item => {
              // создаем у каждого элемента массив из ссылок на его потомков
              item.children = array.filter(i => i.pid === item.id);
              // оставляем в фильтруемом массиве только элементы верхнего уровня
              return item.pid == null;
            });
          let array = response.data.tree;
          this.items = makeTree(array);
          this.principals = response.data.principal;
          this.beneficiars = response.data.beneficiar;
          this.geo_note = response.data.geo_note;
          this.rate_name = response.data.rate_name;
          this.bank_name = response.data.bank_name;
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Не удалось получить данные GEO",
            text: "Возможно нет связи с сервером."
          });
        });
    },
    getGeoForVid(vid) {
      const formData = new FormData();
      formData.append("vid", vid);
      const payload = {
        rate_id: this.rate_id,
        formData
      }
      this.$store.dispatch('getGeoForVid', payload)
      .then(response => {
          switch (vid) {
            case 1:
              Swal.fire({
                icon: "success",
                title: "Загрузка завершена",
                text: "Данные по принципиалам перезагружены"
              });
              this.principals = response.data.geoProduct;
              break;
            case 2:
              Swal.fire({
                icon: "success",
                title: "Загрузка завершена",
                text: "Данные по Бенефициарам перезагружены"
              });
              this.beneficiars = response.data.geoProduct;
              break;
          }
      })
      .catch(error => {
        switch (vid) {
            case 1:
              Swal.fire({
                icon: "error",
                title: "Ошибка загрузки",
                text: "Данные по принципиалам не загружены"
              });
              break;
            case 2:
              Swal.fire({
                icon: "error",
                title: "Ошибка загрузки",
                text: "Данные по Бенефициарам не загружены"
              });
              break;
          }
      })

    },
    updateGeo(vid) {
      var dataToUpdate = 1;
      const formData = new FormData();
      formData.append("vid", vid);
      switch (vid) {
        case 1:
          formData.append("geo", this.principals);
          break;
        case 2:
          formData.append("geo", this.beneficiars);
          break;
      }
      const payload = {
        rate_id: this.rate_id,
        formData
      }
      this.$store.dispatch('updateGeo', payload)
      .then(response => {
          switch (vid) {
            case 1:
              Swal.fire({
                icon: "success",
                title: "Сохранение завершено",
                text: "Данные по принципиалам сохранены"
              });
              break;
            case 2:
              Swal.fire({
                icon: "success",
                title: "Сохранение завершено",
                text: "Данные по Бенефициарам сохранены"
              });
              break;
          }
      })
      .catch(error => {
        switch (vid) {
            case 1:
              Swal.fire({
                icon: "error",
                title: "Не удалось записать данные по принципиалам",
                text: "Возможно нет связи с сервером."
              });
              break;
            case 2:
              Swal.fire({
                icon: "error",
                title: "Не удалось записать данные по Бенефициарам",
                text: "Возможно нет связи с сервером."
              });
              break;
          }
      })
      //

    },
    updateComment() {
      const formData = new FormData();
      formData.append("geo_note", this.geo_note);
      const payload = {
        rate_id: this.rate_id,
        formData
      }
      this.$store.dispatch('updateComment', payload)
        .then(response => {
          Swal.fire({
                icon: "success",
                title: "Сохранение завершено",
                text: "Комментарий успешно сохранен."
              });
        })
        .catch(() => {

              Swal.fire({
                icon: "error",
                title: "Не удалось записать комментарий к Регионам",
                text: "Возможно нет связи с сервером."
              });
        });
    }
  }
};
</script>
